import { SiteAccessDenyCodes } from './siteAccessDenyCodes';

export type ApiErrorBody = {
  code?: string;
  message?: string;
};

export function parseApiError(data: unknown): ApiErrorBody {
  if (!data || typeof data !== 'object') {
    return {};
  }

  const body = data as Record<string, unknown>;
  return {
    code: typeof body.code === 'string' ? body.code : undefined,
    message: typeof body.message === 'string' ? body.message : undefined,
  };
}

export function isLifecycleAccessDeniedCode(code: string | undefined): boolean {
  if (!code) {
    return false;
  }

  return SiteAccessDenyCodes.isLifecycleCode(code);
}
